<p-accordion
  class="m-accordion"
  [styleClass]="styleClass"
  [value]="value"
  [multiple]="multiple"
  (valueChange)="handleValueChange($any($event))"
  (onOpen)="onOpen.emit($event)"
  (onClose)="onClose.emit($event)">
  @for (panel of panels; track panel.value) {
    <p-accordion-panel
      [value]="panel.value"
      [disabled]="panel.disabled"
      class="m-accordion-panel"
      [class.m-accordion-panel--disabled]="panel.disabled"
      [ngClass]="panel.styleClass">
      <p-accordion-header>
        <ng-template #toggleicon let-active="active">
          <span
            class="m-accordion-chevron material-symbols-outlined"
            [class.m-accordion-chevron--active]="active">
            {{ active ? "keyboard_arrow_down" : "chevron_right" }}
          </span>
        </ng-template>
        <ng-container *ngTemplateOutlet="panel.headerTpl"></ng-container>
      </p-accordion-header>
      <p-accordion-content>
        <ng-container *ngTemplateOutlet="panel.bodyTpl"></ng-container>
      </p-accordion-content>
    </p-accordion-panel>
  }
</p-accordion>
<div hidden aria-hidden="true">
  <ng-content></ng-content>
</div>
